import React from 'react';

import {
  Card,
  CardHeader,
  Button,
  CardContent,
  Divider,
} from '@mui/material';

import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { useRedirect } from 'react-admin';
import { useLocation } from 'react-router-dom';
import { isUndefined } from 'lodash';

const SummaryCard = ({
  children,
  title,
  canEdit = false,
  path,
}: {
  children: React.ReactChild;
  title: string;
  canEdit?: boolean;
  path?: string;
}) => {
  const redirect = useRedirect();
  const { state } = useLocation();
  const handleClick = () => {
    if (!isUndefined(path)) redirect(`../${path}`, undefined, undefined, undefined, state);
  };
  return (
    <Card sx={{ backgroundColor: 'background.default', margin: 0 }} variant="outlined">
      <CardHeader
        title={title}
        titleTypographyProps={{ fontWeight: 'bold' }}
        sx={{ color: 'primary.main' }}
        action={<Button onClick={handleClick} sx={{ display: canEdit ? 'flex' : 'none' }} color="primary" endIcon={<EditOutlinedIcon />}>Edit</Button>}
      />
      <Divider />
      <CardContent>
        {children}
      </CardContent>
    </Card>
  );
};

export default SummaryCard;
